import axios from 'axios'
import * as accessTokenInfo from "../../accessToken";

export const fetchBankStatementList = ({commit}, payload) => {
    
    commit('toggleLoadingState', true)
    axios.post('/bankStatement/index.php', payload, accessTokenInfo.accessTokenInfo())
    .then(res => {
        console.log(JSON.stringify(res.data))
        commit('setBankStatementList', {response: res.data.response})
    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })
}

export const updateBankRecoDate = ({commit, dispatch}, payload) => {

    commit('toggleLoadingState', true)
            
    axios.post('/bankStatement/updateBankRecoDate.php', payload, accessTokenInfo.accessTokenInfo())
    .then(res => {      
        commit('displaySuccessNotification', {message: 'Data submitted successfully!!!'});            
    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })
}

export const submitOpeningBalance = ({commit}, payload) => {

    commit('toggleLoadingState', true)
            
    axios.post('/bankStatement/submitOpeningBalance.php', payload, accessTokenInfo.accessTokenInfo())
    .then(res => {     
        commit('displaySuccessNotification', {message: 'Data submitted successfully!!!'});            
    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })
}


// WEBPACK FOOTER //
// ./src/store/modules/bankStatement/actions.js